import { Badge } from "@qw/ui";
import type { FC } from "react";
import type { ProductHistoricalInsights } from "../historical-insights.types";
import { formatDays } from "../insights-utils";

interface Props {
  operational: ProductHistoricalInsights["operational"];
}

export const InsightsOperationalSection: FC<Props> = ({ operational }) => {
  const hasData =
    operational.typicalResponseDays != null ||
    operational.overallFlexibility != null ||
    operational.commonSubjectivities.length > 0 ||
    operational.submissionRequirements.length > 0;

  if (!hasData) {
    return null;
  }

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold">Operational</h3>

      <div className="flex flex-wrap gap-2">
        {operational.typicalResponseDays != null && (
          <Badge variant="secondary">Response: {formatDays(operational.typicalResponseDays)}</Badge>
        )}
        {operational.overallFlexibility && (
          <Badge variant="secondary">Flexibility: {operational.overallFlexibility}</Badge>
        )}
        {operational.timingStrictness && <Badge variant="secondary">Timing: {operational.timingStrictness}</Badge>}
        {operational.minDaysBeforeEffective != null && (
          <Badge variant="secondary">Min lead: {formatDays(operational.minDaysBeforeEffective)}</Badge>
        )}
      </div>

      {operational.submissionRequirements.length > 0 && (
        <div>
          <h4 className="text-xs font-medium text-muted-foreground mb-1">Submission Requirements</h4>
          <ul className="list-disc list-inside text-xs space-y-0.5">
            {operational.submissionRequirements.map((req, i) => (
              <li key={i}>{req}</li>
            ))}
          </ul>
        </div>
      )}

      {operational.commonSubjectivities.length > 0 && (
        <div>
          <h4 className="text-xs font-medium text-muted-foreground mb-1">Common Subjectivities</h4>
          <ul className="list-disc list-inside text-xs space-y-0.5">
            {operational.commonSubjectivities.map((sub, i) => (
              <li key={i}>{sub}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
